// extracted by mini-css-extract-plugin
export default {"track":"Accordian_track__FWea+"};